// previous-route.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map, pairwise } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PreviousRouteService {
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;

  constructor(private router: Router) {
    // لو فتحت الصفحة مباشرة: استعمل referrer داخل نفس الدومين كـ prev
    if (!sessionStorage.getItem('prevUrl') && document.referrer) {
      try {
        const ref = new URL(document.referrer);
        if (ref.origin === location.origin) {
          const from = ref.pathname + ref.search + ref.hash;
          sessionStorage.setItem('prevUrl', from);
        }
      } catch {}
    }

    // حدث current أول مرة
    this.currentUrl = this.router.url;
    sessionStorage.setItem('currUrl', this.currentUrl);

    // تتبع كل تنقلات الـ SPA
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        map((e) => e.urlAfterRedirects),
        pairwise() // [previous, current] لكل تنقل
      )
      .subscribe(([prev, curr]) => {
        this.previousUrl = prev;
        this.currentUrl = curr;
        sessionStorage.setItem('prevUrl', prev);
        sessionStorage.setItem('currUrl', curr);
      });
  }

  getPreviousUrl(): string | null {
    return this.previousUrl
      || sessionStorage.getItem('prevUrl')
      || null;
  }

  cameFrom(keyword: string): boolean {
    const prev = this.getPreviousUrl() ?? '';
    return new RegExp(`\\b${keyword}\\b`, 'i').test(prev);
  }
}
